import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/cash-ledger";

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(data) {
  return axios.post(BASE, data);
}

export function softEdit(id, data) {
  return axios.post(`${BASE}/${id}/soft-edit`, data);
}

export function reverse(id) {
  return axios.post(`${BASE}/${id}/reverse`);
}
